<template>
  <div class="fragment"></div>
<!--  <SearchEngine/>-->
</template>

<script>
  // import SearchEngine from "../../../../../../coreComponents/SearchEngine/SearchEngine";

  export default {
    name: "ProcessFBMReportHead",
    components:{
      // SearchEngine,
    },
  }
</script>

<style scoped>

</style>